import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import BackLink from "../components/BackLink";
import JourneyProgress from "../components/JourneyProgress";
import { ReactComponent as IconLock } from "../assets/icon-lock.svg";
import { Link } from "react-router-dom";
import classes from "./QuoteSent.module.scss";

function BookConfirmed() {
  return (
    <Container className={`phone-container ${classes.quoteSentContainer}`}>
      <BackLink desktop />
      <Row className="content">
        <Col xs={12}>
          <JourneyProgress mobile className={"mt-2"} />
          <div className={classes["quote-sent"]}>
            <IconLock className={"mt-4"} />
            <h1 className={"mt-4 quote-sent"}>Booking Confirmed</h1>
            <p>
              Thank you, your booking has been confirmed. An email has been sent to your
              inbox with the next steps.
            </p>
          </div>
        </Col>
      </Row>
      <Row className={`${classes.bottomPanel} border-top`}>
        <Col xs={6}>
          <Link to={"/"}>
            <Button
              variant={"outline-primary"}
              className={"btn-md w-100"}
              type={"submit"}
            >
              Return To Website
            </Button>
          </Link>
        </Col>
        <Col xs={6}>
          <Button className={"btn-md w-100"} type={"submit"}>
            Return To Units
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default BookConfirmed;
